module.exports = __webpack_public_path__ + "static/media/ProgressiveRelaxationActivity.9b78e9ab.mp3";